export default {
    data() {
        return {
            checkValue: false,
        }
    },
    watch: {
        checkValue: function (val) {
            console.log('checkValue', val)
        },
    },
    methods: {
        doToast(title, message, variant) {
            this.$bvToast.toast(message, {
                title,
                variant,
                solid: true,
                toaster: 'b-toaster-top-center',
                appendToast: true,
            })
        },
        /**
         *
         * @param {string} componentName The space separated name of the component
         * @param {string} action  create | update | delete | duplicate
         * @param {string} status success | warning | error
         * @param {string} message The message displayed to the user
         */
        genericToast(componentName, action, status, message) {
            let title = ''
            if (action.toLowerCase() === 'duplicate') {
                title = `${action} ${componentName}`
            } else {
                title = `${componentName} ${action}`
            }

            this.$bvToast.toast(message, {
                title: title,
                variant: status,
                solid: true,
                toaster: 'b-toaster-top-center',
                appendToast: true,
            })
        },

        async confirmMessage(title, message) {
            const value = await this.$bvModal.msgBoxConfirm(message, {
                title,
                buttonSize: 'sm',
                headerClass: "p-0",
                footerClass: "d-flex justify-content-center border-0",
                contentClass: "custom-model-wrap",
                titleClass: "py-1",
                okVariant: 'info',
                okTitle: this.$translate('yes'),
                cancelTitle: this.$translate('no'),
                cancelVariant: 'info',
                hideHeaderClose: false,
                centered: true,
            })
            return value
        },

        async optionsMessage(title, content) {
            // const self = this
            let optionSelected = false
            const h = this.$createElement
            const titleVNode = h('div', { domProps: { innerHTML: title } })
            const messageVNode = h('div', { class: 'form-check' }, [
                h('label', { class: 'form-check-label ms-4 form-check-inline' }, [
                    h('input', {
                        attrs: {
                            type: 'checkbox',
                        },
                        class: 'form-check-input',
                        on: {
                            input: function (event) {
                                console.log('checkValue--event', event.target.checked);
                                optionSelected = event.target.checked;
                            },
                        },
                    }),
                    content,
                    h('i', { class: 'input-helper' }),
                ]),
            ]);




            const confirmed = await this.$bvModal.msgBoxConfirm(
                [messageVNode],
                {
                    title: [titleVNode],
                    buttonSize: 'sm',
                    headerClass: "p-0",
                    footerClass: "d-flex justify-content-center border-0",
                    contentClass: "custom-model-wrap",
                    titleClass: "py-1",
                    okVariant: 'info',
                    okTitle: this.$translate('yes'),
                    cancelTitle: this.$translate('no'),
                    cancelVariant: 'info',
                    hideHeaderClose: false,
                    centered: true,
                }
            )

            console.log('optionSelected', optionSelected)
            return { confirmed, optionSelected }
        },
    },
}
